import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/header-one";
import Footer from "@layout/footer/footer-one";
import PageHeader from "@components/pageheader";
import { Container, Row, Col } from "@ui/wrapper";
import Heading from "@ui/heading";
import Sidebar from "@containers/blog/sidebar";
import Blog from "@components/blog/layout-two";
import { BlogListWrapper, BlogBoxWrapper, BlogBox } from './cate-template.style'

const CateTemplate = ({ data, pageContext, location, ...restProps }) => {
	const { headingStyle } = restProps;
	const blogs = data.allMarkdownRemark.edges;
	const { cate } = pageContext;
	return (
		<Layout location={location}>
			<Seo title={`Categories: ${cate}`} />
			<Header />
			<PageHeader
				pageContext={pageContext}
				location={location}
				title={`Categories: ${cate}`}
			/>
			<main className="site-wrapper-reveal">
				<BlogListWrapper>
					<Container>
						<Row>
							<Col lg={{ span: 4, order: 1 }} xs={{ span: 12, order: 2 }}>
								<Sidebar />
							</Col>
							<Col lg={{ span: 8, order: 2 }} xs={{ span: 12, order: 1 }}>
								<Heading {...headingStyle}>Interesting articles <span>updated monthly</span></Heading>
								<BlogBoxWrapper>
									{blogs.map(blog => (
										<BlogBox key={blog.node.fields.slug}>
											<Blog content={blog.node} />
										</BlogBox>
									))}
								</BlogBoxWrapper>
							</Col>
						</Row>
					</Container>
				</BlogListWrapper>
			</main>
			<Footer />
		</Layout>
	)
}

export const query = graphql`
    query BlogByCateQuery($cate: String!){
        allMarkdownRemark(
            sort: {fields: frontmatter___date, order: DESC}, 
            filter: {frontmatter: {categories: {in: [$cate]}}}
        ) {
            edges {
                node {
                    frontmatter {
						type
                        categories
                        title
                        author {
                            name
                            image {
                                childImageSharp {
									gatsbyImageData(
										layout: FIXED
										width: 32
										height: 32
										placeholder: TRACED_SVG
										formats: WEBP
										quality: 100
									)
                                }
                            }
                        }
                        format
                        quote_text
                        quote_author
                        video_link
                        date(formatString: "LL")
                        featured_image {
                            childImageSharp {
								gatsbyImageData(
									layout: CONSTRAINED
									width: 770
									height: 420
									placeholder: TRACED_SVG
									formats: WEBP
									quality: 100
								)
                            }
                        }
                    }
                    fields {
                        slug
                        authorId
                        dateSlug
                    }
                    excerpt
                }
            }
        }
    }
`;


CateTemplate.propTypes = {
	headingStyle: PropTypes.object
}

CateTemplate.defaultProps = {
	headingStyle: {
		as: 'h3',
		mb: '70px',
		textalign: 'center',
		child: {
			color: 'primary'
		},
		responsive: {
			medium: {
				mb: '50px'
			}
		}
	}
}
export default CateTemplate;